"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  _actionFor: true,
  forwardTo: true,
  getActionForwardAddress: true,
  isForwardAction: true,
  unwrap: true,
  wrapTo: true,
  ActionTypes: true
};
Object.defineProperty(exports, "ActionTypes", {
  enumerable: true,
  get: function get() {
    return _actionTypes["default"];
  }
});
Object.defineProperty(exports, "_actionFor", {
  enumerable: true,
  get: function get() {
    return _actionWrapper._actionFor;
  }
});
Object.defineProperty(exports, "forwardTo", {
  enumerable: true,
  get: function get() {
    return _actionWrapper.forwardTo;
  }
});
Object.defineProperty(exports, "getActionForwardAddress", {
  enumerable: true,
  get: function get() {
    return _actionWrapper.getActionForwardAddress;
  }
});
Object.defineProperty(exports, "isForwardAction", {
  enumerable: true,
  get: function get() {
    return _actionWrapper.isForwardAction;
  }
});
Object.defineProperty(exports, "unwrap", {
  enumerable: true,
  get: function get() {
    return _actionWrapper.unwrap;
  }
});
Object.defineProperty(exports, "wrapTo", {
  enumerable: true,
  get: function get() {
    return _actionWrapper.wrapTo;
  }
});
var _actions = require("./actions");
Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _actions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actions[key];
    }
  });
});
var _visStateActions = require("./vis-state-actions");
Object.keys(_visStateActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _visStateActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _visStateActions[key];
    }
  });
});
var _uiStateActions = require("./ui-state-actions");
Object.keys(_uiStateActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _uiStateActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _uiStateActions[key];
    }
  });
});
var _mapStateActions = require("./map-state-actions");
Object.keys(_mapStateActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mapStateActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mapStateActions[key];
    }
  });
});
var _mapStyleActions = require("./map-style-actions");
Object.keys(_mapStyleActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mapStyleActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mapStyleActions[key];
    }
  });
});
var _identityActions = require("./identity-actions");
Object.keys(_identityActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _identityActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _identityActions[key];
    }
  });
});
var _providerActions = require("./provider-actions");
Object.keys(_providerActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _providerActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _providerActions[key];
    }
  });
});
var _actionWrapper = require("./action-wrapper");
var _actionTypes = _interopRequireDefault(require("../constants/action-types"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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